import { render, staticRenderFns } from "./From.vue?vue&type=template&id=819cbe1a&scoped=true"
import script from "./From.vue?vue&type=script&lang=js"
export * from "./From.vue?vue&type=script&lang=js"
import style0 from "./From.vue?vue&type=style&index=0&id=819cbe1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819cbe1a",
  null
  
)

export default component.exports